module.exports = __webpack_public_path__ + "img/billto.59f86cbf.svg";